var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 18.8583C9.44164 18.8583 8.87497 18.7333 8.4333 18.475L3.84997 15.8333C1.9833 14.575 1.86664 14.3833 1.86664 12.4083V7.59163C1.86664 5.61663 1.97497 5.42496 3.8083 4.18329L8.42497 1.51663C9.29997 1.00829 10.675 1.00829 11.55 1.51663L16.15 4.16663C18.0166 5.42496 18.1333 5.61663 18.1333 7.59163V12.4C18.1333 14.375 18.025 14.5666 16.1916 15.8083L11.575 18.475C11.125 18.7333 10.5583 18.8583 9.99997 18.8583ZM9.99997 2.39163C9.64997 2.39163 9.3083 2.45829 9.06664 2.59996L4.4833 5.24996C3.12497 6.16663 3.12497 6.16663 3.12497 7.59163V12.4C3.12497 13.825 3.12497 13.825 4.51664 14.7666L9.06664 17.3916C9.5583 17.675 10.45 17.675 10.9416 17.3916L15.525 14.7416C16.875 13.825 16.875 13.825 16.875 12.4V7.59163C16.875 6.16663 16.875 6.16663 15.4833 5.22496L10.9333 2.59996C10.6916 2.45829 10.35 2.39163 9.99997 2.39163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.125C8.275 13.125 6.875 11.725 6.875 10C6.875 8.275 8.275 6.875 10 6.875C11.725 6.875 13.125 8.275 13.125 10C13.125 11.725 11.725 13.125 10 13.125ZM10 8.125C8.96667 8.125 8.125 8.96667 8.125 10C8.125 11.0333 8.96667 11.875 10 11.875C11.0333 11.875 11.875 11.0333 11.875 10C11.875 8.96667 11.0333 8.125 10 8.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.9abaa20138cd075b6579ccdfe4616893.svg";
export { ForwardRef as ReactComponent };